export const OFLC_DELETE_CASE = "OFLC_DELETE_CASE";
export const OFLC_SUBMIT_CASE = "OFLC_SUBMIT_CASE";
export const OFLC_SAVE_CASE = "OFLC_SAVE_CASE";

export const OFLC_CASE_UPDATE_SUCCESS = "OFLC_CASE_UPDATE_SUCCESS";
export const OFLC_CASE_UPDATE_FAILURE = "OFLC_CASE_UPDATE_FAILURE";

export const OFLC_SUBMIT_CASE_SUCCESS = "OFLC_SUBMIT_CASE_SUCCESS";
export const OFLC_SUBMIT_CASE_FAILURE = "OFLC_SUBMIT_CASE_FAILURE";

export const OFLC_CASE_DELETE_SUCCESS = "OFLC_CASE_DELETE_SUCCESS";
export const OFLC_CASE_DELETE_FAILURE = "OFLC_CASE_DELETE_FAILURE";

export const CLEAR_STATUS_MODAL = "CLEAR_STATUS_MODAL";

export function deleteCase(payload) {
  return {
    type: OFLC_DELETE_CASE,
    payload: payload,
  };
}

export function submitCase(payload) {
  return {
    type: OFLC_SUBMIT_CASE,
    payload: payload,
  };
}

export function submitCaseFailure(payload) {
  return {
    type: OFLC_SUBMIT_CASE_FAILURE,
    payload: payload,
  };
}

export function submitCaseSuccess(payload) {
  return {
    type: OFLC_SUBMIT_CASE_SUCCESS,
    payload: payload,
  };
}

export function saveCase(payload) {
  return {
    type: OFLC_SAVE_CASE,
    payload: payload,
  };
}

export function saveCaseFailure(payload) {
  return {
    type: OFLC_CASE_UPDATE_FAILURE,
    payload: payload,
  };
}

export function saveCaseSuccess(payload) {
  return {
    type: OFLC_CASE_UPDATE_SUCCESS,
    payload: payload,
  };
}

export function deleteCaseFailure(payload) {
  return {
    type: OFLC_CASE_DELETE_FAILURE,
    payload: payload,
  };
}

export function deleteCaseSuccess(payload) {
  return {
    type: OFLC_CASE_DELETE_SUCCESS,
    payload: payload,
  };
}

export function clearStatusModal(payload) {
  return {
    type: CLEAR_STATUS_MODAL,
    payload: payload,
  };
}
